// import { AuthProvider } from "./contexts/Auth";
import { history } from "./_helpers/history";
import { Routes } from "./routes/Routes";
import "antd/dist/antd.css";
import "./styles/index.css";
import "./styles/secciones/secciones.css";

function App() {
  return (
    <Routes history={history} />
  );
}

export default App;
